<template>
  <v-container fluid>
    <v-card>
      <v-card-title> All Clients </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-data-table
          :loading="loading"
          :headers="headers"
          :items="AllClients"
          :items-per-page="10"
          :search="search"
          show-select
          v-model="selectedList"
          item-key="_id"
        >
          <template v-slot:top>
            <v-toolbar flat color="grey lighten-4">
              <p v-if="selectedList.length">
                {{ `Checked Clients: ${selectedList.length}` }}
              </p>
              <v-spacer></v-spacer>
              <v-text-field
                solo
                dense
                class="mt-5 mr-3 d-print-none"
                name="SearchText"
                label="SEARCH Client"
                id="Searchid"
                v-model.trim="search"
              ></v-text-field>
              <v-btn
                v-if="AllClients.length"
                icon
                class="d-print-none"
                small
                color="success"
                @click="PrintPage"
              >
                <v-icon>fas fa-print</v-icon>
              </v-btn>
            </v-toolbar>
          </template>

          <template v-slot:[`item.more`]="{ item }">
            <base-row-layout>
              <!-- Edite Client Icon -->
              <div>
                <v-btn icon color="primary">
                  <v-icon class="mr-2" @click="ClientEdite(item)">
                    fas fa-pencil-alt
                  </v-icon>
                </v-btn>
              </div>
              <!-- Client Show Balance Icon -->
              <div>
                <v-btn icon color="primary">
                  <ShowBalance
                    :ReqURL="`${ClintURL}/balance`"
                    :Title="item.Name"
                    :query="{ _id: item._id }"
                  >
                  </ShowBalance>
                </v-btn>
              </div>

              <!-- CLIENT NEW TRANSACTION VIEW -->
              <div>
                <qaas-tran
                  :BaseURL="ClintURL"
                  :CustomerID="{ FullName: item.Name, AccountNumber: item._id }"
                >
                  <template v-slot:Details="{ row }">
                    <SalesDetails v-if="row.AccountName == 'Sales'" :item="row">
                      {{ row.Details | filterCode }}
                    </SalesDetails>
                    <!-- <p v-else>{{ row.Details }}</p> -->
                    <v-btn small disabled v-else text color="primary">{{
                      row.info || row.Details
                    }}</v-btn>
                  </template>
                  <template v-slot:Ref="{ row: TranItem }">
                    <base-row-layout>
                      <template
                        v-if="
                          TranItem && TranItem.Ref.search(/^(REP|OLD)-/) !== -1
                        "
                      >
                        <div>
                          <!-- <div v-if="TranItem && TranItem.Ref.search(/^OLD-/) !== -1"> -->
                          <BaseDelete
                            v-if="UsersToken.UserType === 'Admin'"
                            :OnFinish="
                              () => {
                                TranItem.OnSearch(
                                  TranItem.fromDate,
                                  TranItem.toDate
                                );
                              }
                            "
                            :DelQuery="{ Ref: TranItem.Ref }"
                            DelUrl="/Reports/deleteRef"
                          >
                            <template #title>
                              DELETE
                              <span class="black--text">{{ item.Name }}</span>
                            </template>

                            <v-row>
                              <v-col>{{ TranItem.date }}</v-col>

                              <v-col>{{ TranItem.Details }}</v-col>
                              <v-col>{{
                                TranItem.Amount &&
                                  TranItem.Amount.toLocaleString()
                              }}</v-col>
                            </v-row>
                          </BaseDelete>
                        </div>
                        <!-- Edite Date and Details -->
                        <div>
                          <base-edite-date
                            :Info="TranItem"
                            :BaseURL="ClintURL"
                            :FinishedWithdrow="
                              () => {
                                TranItem.OnSearch(
                                  TranItem.fromDate,
                                  TranItem.toDate
                                );
                              }
                            "
                          ></base-edite-date>
                        </div>
                      </template>

                      <template v-else>
                        <!-- <p>Can't dell</p> -->
                        <!-- <p>{{ TranItem }}</p> -->
                        <div v-if="TranItem.AccountName == 'Sales'">
                          <PrintView
                            :key="TranItem.Ref + TranItem.AccountName"
                            :SaleOrder="{ ...TranItem, Description: item._id }"
                          ></PrintView>
                        </div>
                        <div v-else>
                          {{ TranItem.AccountName }}
                        </div>
                      </template>
                    </base-row-layout>
                  </template>
                </qaas-tran>
              </div>
              <!-- Client Transaction view -->
              <div>
                <ClientTran
                  :BaseURL="ClintURL"
                  :Title="item.Name"
                  :TranInfo="item"
                  :headers="headersTran"
                >
                  <template v-slot:Details="{ row }">
                    <SalesDetails v-if="row.AccountName == 'Sales'" :item="row">
                      {{ row.Details | filterCode }}
                    </SalesDetails>
                    <!-- <p v-else>{{ row.Details }}</p> -->
                    <v-btn small disabled v-else text color="primary">{{
                      row.info || row.Details
                    }}</v-btn>
                  </template>
                  <template v-slot:Ref="{ row: TranItem }">
                    <base-row-layout>
                      <template
                        v-if="
                          TranItem && TranItem.Ref.search(/^(REP|OLD)-/) !== -1
                        "
                      >
                        <div>
                          <!-- <div v-if="TranItem && TranItem.Ref.search(/^OLD-/) !== -1"> -->
                          <BaseDelete
                            v-if="UsersToken.UserType === 'Admin'"
                            :OnFinish="
                              () => {
                                TranItem.OnSearch(
                                  TranItem.fromDate,
                                  TranItem.toDate
                                );
                              }
                            "
                            :DelQuery="{ Ref: TranItem.Ref }"
                            DelUrl="/Reports/deleteRef"
                          >
                            <template #title>
                              DELETE
                              <span class="black--text">{{ item.Name }}</span>
                            </template>

                            <v-row>
                              <v-col>{{ TranItem.date }}</v-col>

                              <v-col>{{ TranItem.Details }}</v-col>
                              <v-col>{{
                                TranItem.Amount &&
                                  TranItem.Amount.toLocaleString()
                              }}</v-col>
                            </v-row>
                          </BaseDelete>
                        </div>
                        <!-- Edite Date and Details -->
                        <div>
                          <base-edite-date
                            :Info="TranItem"
                            :BaseURL="ClintURL"
                            :FinishedWithdrow="
                              () => {
                                TranItem.OnSearch(
                                  TranItem.fromDate,
                                  TranItem.toDate
                                );
                              }
                            "
                          ></base-edite-date>
                        </div>
                      </template>

                      <template v-else>
                        <!-- <p>Can't dell</p> -->
                        <!-- <p>{{ TranItem }}</p> -->
                        <div v-if="TranItem.AccountName == 'Sales'">
                          <PrintView
                            :key="TranItem.Ref + TranItem.AccountName"
                            :SaleOrder="{ ...TranItem, Description: item._id }"
                          ></PrintView>
                        </div>
                        <div v-else>
                          {{ TranItem.AccountName }}
                        </div>
                      </template>
                    </base-row-layout>
                  </template>
                </ClientTran>
              </div>
              <!-- Client More Options -->
              <div>
                <MoreOptions
                  :key="item._id + 'MoreOption'"
                  :ClientInfo="item"
                ></MoreOptions>
              </div>
            </base-row-layout>
          </template>
        </v-data-table>
      </v-card-text>
      <v-card-actions>
        <NewClint
          :OnEdite="OnEdite"
          :isEditing="isEditing"
          :OnFinish="Onfinshed"
          @input="isEditing = $event"
        ></NewClint>
      </v-card-actions>
    </v-card>
  </v-container>
</template>
<script>
import { mapGetters } from "vuex";
import { printTable } from "@/Mixins/printTable";
import printJS from "print-js";
export default {
  mixins: [printTable],
  components: {
    NewClint: () => import("@/components/Branches/Clients/newClinet.vue"),
    MoreOptions: () => import("@/components/Branches/Clients/ClientMore.vue"),
    ClientTran: () => import("@/components/Branches/Clients/clientTran.vue"),
    ShowBalance: () => import("@/components/util/showBalance.vue"),
    PrintView: () =>
      import("@/components/Branches/Sales/Options/printSaleReport.vue"),
    SalesDetails: () =>
      import("@/components/Branches/Sales/Options/SalesDetails.vue"),
    QaasTran: () => import("@/views/Branches/QAAS/QaasTran"),
  },
  data() {
    return {
      ClintURL: "/customer",
      search: "",
      isEditing: false,
      loading: false,
      selectedList: [],
      AllClients: [],
      headers: [
        {
          text: "Reg Date",
          align: "left",
          value: "date",
          class: "teal darken-3 white--text",
        },
        {
          text: "Name",
          align: "left",
          value: "Name",
          class: "teal darken-3 white--text",
        },
        {
          text: "Phone",
          value: "phone",
          class: "teal darken-3 white--text",
        },
        {
          text: "More",
          value: "more",
          align: "center",
          class: "teal darken-3 white--text",
          sortable: false,
        },
      ],
      headersTran: [
        {
          text: "Date",
          align: "left",
          value: "date",
        },
        { text: "Account", value: "AccountName" },
        { text: "Details", value: "Details" },
        // { text: "Cash Type", value: "AmountType" },
        { text: "Dr", value: "deposit" },
        { text: "Cr", value: "withdraw", class: "blue--text" },
        { text: "User", value: "User" },
        { text: "Ref", value: "Ref" },
      ],
      OnEdite: {},
    };
  },

  computed: {
    ...mapGetters(["UsersToken"]),
  },

  methods: {
    PrintPage() {
      // console.log(this.UsersToken.UserBranch);
      let prHeader = [
        { value: "index", text: "#" },
        ...this.headers.filter(
          head =>
            head.text !== "Ref" &&
            head.text !== "More" &&
            head.text !== "Reg Date"
        ),
        // { value: "balance", text: "balance" },
      ];
      let myTitle = `${this.UsersToken.UserBranch} clients`;
      const myPrintTable = this.PrintReport(
        this.AllClients.reverse(),
        prHeader,
        myTitle.toUpperCase()
      );

      printJS({
        printable: myPrintTable,
        type: "html",
        style: this.CustomStyle("#ff5252", "#ffffff"),
        repeatTableHeader: false,
      });
    },
    ClientEdite(client) {
      // console.log(client);
      this.isEditing = true;
      this.OnEdite = client;
    },

    loadAllClients() {
      this.loading = true;
      this.$store
        .dispatch("GET_ONLY", this.ClintURL)
        .then(result => {
          // console.log(result)
          this.AllClients = result.data;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },

    Onfinshed(result) {
      this.AllClients = result;
      this.isEditing = false;
    },
  },
  mounted() {
    this.loadAllClients();
  },
};
</script>
